import gql from 'graphql-tag'

const REQUEST_UPLOAD_URL = gql`
  mutation ($mime: String!, $extension: String!, $filename: String) {
    requestUploadUrl(mime: $mime, extension: $extension, filename: $filename) {
      uploadUrl
      objectPath
      storedFilename
      publicUrl
      publicUrlThumb
      type
    }
  }
`

const CONFIRM_UPLOAD = gql`
  mutation ($input: ConfirmUploadInput!) {
    confirmUpload(input: $input) {
      id
      filename
      extension
      url
      urlThumb
      type
      size
    }
  }
`

/**
 * Sube un archivo directo a GCS (Signed URL) y registra metadata en Laravel.
 * @param {import('@apollo/client').ApolloClient} apollo
 * @param {File} file
 */
export async function uploadFileToGcs(apollo, file) {
  const fullName = file.name || 'file'
  const dot = fullName.lastIndexOf('.')
  const extension = dot >= 0 ? fullName.slice(dot + 1).toLowerCase() : 'bin'
  const filename = dot >= 0 ? fullName.slice(0, dot) : fullName
  const mime = file.type || 'application/octet-stream'

  const { data } = await apollo.mutate({
    mutation: REQUEST_UPLOAD_URL,
    variables: { mime, extension, filename },
  })

  const info = data.requestUploadUrl
  const uploadResponse = await fetch(info.uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': mime },
  })

  if (!uploadResponse.ok) {
    throw new Error(`Error al subir a GCS (${uploadResponse.status})`)
  }

  const confirm = await apollo.mutate({
    mutation: CONFIRM_UPLOAD,
    variables: {
      input: {
        objectPath: info.objectPath,
        storedFilename: info.storedFilename,
        filename,
        extension,
        mime,
        size: file.size,
        type: info.type,
      },
    },
  })

  return confirm.data.confirmUpload
}
